import { render, staticRenderFns } from "./skill-form-dialog.vue?vue&type=template&id=36fcff48&scoped=true"
import script from "./skill-form-dialog.vue?vue&type=script&lang=js"
export * from "./skill-form-dialog.vue?vue&type=script&lang=js"
import style0 from "./skill-form-dialog.vue?vue&type=style&index=0&id=36fcff48&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36fcff48",
  null
  
)

export default component.exports